/**
 * Notifications for successful tenant API writes.
 *
 * Lets a screen react to changes made anywhere beneath it — App Studio re-checks whether an app's
 * draft differs from what is published after any edit to the draft — without every dialog and
 * panel that writes having to report back through props.
 */
export type ApiMutationListener = (path: string) => void;

const listeners = new Set<ApiMutationListener>();

const READ_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

/** Registers `listener` for every successful write; returns the function that removes it. */
export function subscribeToApiMutations(listener: ApiMutationListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Tells every listener that a request to `path` succeeded, if `method` is a write. */
export function notifyApiMutation(path: string, method: string | undefined): void {
  if (READ_METHODS.has((method ?? "GET").toUpperCase())) {
    return;
  }
  for (const listener of [...listeners]) {
    listener(path);
  }
}
